<template>
    <div id="users-manage" v-if="users">
        <button type="button" v-on:click="openAddEditModal()">DODAJ</button>
        <button type="button" v-on:click="openBulkPrintModal()">BULK PRINT</button>
        <div class="search-bar" ><input type="text" placeholder="Traži..." v-model="searchText" v-on:input="searchUsers" /></div>
        <div class="users-header">
            <span>EMAIL</span>
            <span>IME</span>
            <span>PREZIME</span>
            <span>ROLA</span>
            <span>AKTIVAN</span>
            <span>TVRTKA</span>
        </div>
        <div class="user" v-for="user in users" v-bind:key="user.id">
            <span>{{user.email}}</span>
            <span>{{user.firstName}}</span>
            <span>{{user.lastName}}</span>
            <span>{{user.role}}</span>
            <span>{{user.isActivated}}</span>
            <template v-if="user.company">
                <span>{{user.company.name}}</span>
            </template>
            <span v-else>
                NEMA
            </span>
            <button type="button" v-on:click="printUser(user)">ISPRINTAJ</button>
            <button type="button" v-on:click="openAddEditModal(user)">UREDI</button>
        </div>
        <AddEditUserModal v-if="modalVisible" v-on:cancel="resetUser" v-on:save="saveUser" v-bind:user="userForModal" v-bind:roles="userRoles" v-bind:companies="allCompanies" />
        <BulkPrintModal v-if="bulkModalVisible" v-on:confirm="bulkPrint" v-on:cancel="bulkModalVisible = false" v-bind:roles="userRoles" />
        <div id="user-print">
            <div class="first-name-print"></div>
            <div class="last-name-print"></div>
            <div class="company-print"></div>
        </div>
    </div>
</template>

<script>
    import throttle from 'lodash.throttle';
    import debounce from 'lodash.debounce';
    import { Printd } from 'printd';
    import AddEditUserModal from '@/components/admin/users/AddEditUserModal.vue';
    import BulkPrintModal from '@/components/admin/users/BulkPrintModal.vue';

    export default {
        name: 'UserManage',
        data() {
            return {
                users: [],
                usersBackup: [],
                userForModal: {},
                modalVisible: false,
                bulkModalVisible: false,
                userRoles: [],
                skipCount: 0,
                takeCount: 30,
                allCompanies: [],
                userCode: "",
                searchText: ""
            }
        },
        components: {
            AddEditUserModal,
            BulkPrintModal
        },
        methods: {
            printUser: function(user) { 
                let userPrintDivs = document.querySelectorAll('#user-print div');
            
                userPrintDivs[0].innerHTML = user.firstName;
                userPrintDivs[1].innerHTML = user.lastName;
                userPrintDivs[2].innerHTML = user.company ? user.company.name === 'Bundesdruckerei' ? 'Maurer Electronics' : user.company.name : '';

                // Arial fallback font when Fuse is not installed on machine
                const cssText = `
                    @media print {
                        @page { margin: 0; }
                        body { margin: 1.6cm; }
                    }

                    #user-print div {
                        font-family: "Fuse V.2 Display", "Arial";
                        font-weight: 600;
                    }

                    .first-name-print {
                        margin-top: 350px;
                        font-size: 44px;
                        font-weight: 700;
                    }

                    .last-name-print {
                        font-size: 32px;
                    }

                    .company-print {
                        font-size: 24px;
                    }`;

                const d = new Printd();

                d.print(document.getElementById('user-print'), [ cssText ]);

                if(!user.isPrinted)
                    this.$axios.post(`${this.$API_URL}/user/mark-as-printed`, { id: user.id })
                        .catch(() => {
                            alert('Isprintan nepostojeći korisnik.');
                        });
            },
            bulkPrint: function(roleForPrint) {
                this.bulkModalVisible = false;

                this.$axios.get(`${this.$API_URL}/user/in-role/${roleForPrint}`).then(response => {
                    for(let user of response.data)
                        this.printUser(user);
                });
            },
            openAddEditModal: function (user) {
                this.userForModal = user ? user : {};
                this.modalVisible = true;
            },
            openBulkPrintModal: function () {
                this.bulkModalVisible = true;
            },
            saveUser: function (userToSave, shouldPrint) {
                if(userToSave.id)
                    this.$axios.post(`${this.$API_URL}/user/edit`, userToSave
                    ).catch(() => {
                        this.$axios.get(`${this.$API_URL}/user/${userToSave.id}`).then(response => {
                            this.users.splice(this.users.findIndex(user => user.id === userToSave.id), 1, response.data);
                            alert('Edit korisnika neuspješan. Nevaljan unos ili zabranjen pristup.');
                        }).catch(() => {
                            alert('Pokušan je edit nepostojećeg korisnika!');
                        });
                    });
                else
                    this.$axios.post(`${this.$API_URL}/user/add`, userToSave
                    ).then(response => {
                        userToSave.isActivated = true;
                        userToSave.id = response.data;
                        this.users.push(userToSave);

                        if(shouldPrint)
                            this.printUser(userToSave);
                    }).catch(() => {
                        alert('Dodavanje korisnika ili print neuspješni.');
                    });
                this.modalVisible = false;
            },
            resetUser: function (userToReset) {
                if(userToReset.id)
                    this.$axios.get(`${this.$API_URL}/user/${userToReset.id}`).then(response => {
                        this.users.splice(this.users.findIndex(user => user.id === userToReset.id), 1, response.data); });
                this.modalVisible = false;
            },
            fetchUsersBatch: function () {
                this.$axios.get(`${this.$API_URL}/user/take-users`, {
                    params: {
                        skipCount: this.skipCount,
                        takeCount: this.takeCount
                    }
                    }).then(response => {
                        this.users.push(...response.data);
                        this.usersBackup.push(...response.data);
                        this.skipCount += response.data.length;
                    });
            },
            handleScroll: function() {
                let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;

                // I know this will fetch duplicate records for just added users if you scroll to the bottom, but it isn't that big of an issue.
                if (bottomOfWindow && !this.searchText.length)
                    this.fetchUsersBatch();
            },
            searchUsers: function() {
                let text = this.searchText;

                if(!text.length)
                {
                    this.users = [...this.usersBackup];
                    return;
                }

                if(text.length < 3)
                    return;

                debounce(() => {
                    this.$axios.get(`${this.$API_URL}/user/search/${text}`).then(response => {
                            if(this.searchText.length >= 3)
                                this.users = [...response.data];
                        });
                }, 1000)();
            }
        },
        created() {
            this.fetchUsersBatch();

            this.$axios.get(`${this.$API_URL}/user/user-role-enum`).then(response => {
                this.userRoles = response.data;
            });

            this.$axios.get(`${this.$API_URL}/companies/all-companies`).then(response => {
                this.allCompanies = response.data;
            });
        },
        mounted() {
            window.addEventListener('scroll', throttle(this.handleScroll, 2000));
        }
    }
</script>

<style scoped>
    #users-manage {
        padding: 20px;
    }

    .users-header span,
    .user span {
        word-wrap: break-word;
        display: inline-block;
        height: auto;
        width: 12%;
        margin-right: 5px;
        vertical-align: center;
    }

    button {
        padding: 6px;
    }

    #user-print {
        display: none;
    }

    .search-bar {
        padding: 20px 50px;
    }

    .search-bar input {
        width: 100%;
    }
</style>